import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Driver from 'driver.js';
import IndexPage from 'flarum/forum/components/IndexPage'

app.initializers.add('justoverclock/intro-tutorial', () => {
  extend(IndexPage.prototype, 'oncreate', function () {
    const user = app.session.user;

    if (!user && window.innerWidth > 992) {
      if (localStorage.getItem('noTutorialBefore') === null) {
        setTimeout(() => {
          const driver = new Driver({
            allowClose: false,
            animate: true,
          });

          driver.defineSteps([
            {
              element: 'li.item-signUp',
              popover: {
                className: 'first-step-popover-class',
                title: 'Registrati su Flarum.it',
                description: 'Da qui puoi registrarti a Flarum.it ed incominciare a ricevere supporto gratuitamente!',
                position: 'bottom-center',
                doneBtnText: 'Fatto',
                closeBtnText: 'Chiudi',
                nextBtnText: 'Successivo',
                prevBtnText: 'Precedente',
              }
            },
            {
              element: 'li.item-nav',
              popover: {
                title: 'Scegli un Tag',
                description: 'Scegli un tag che identifica meglio la discussione che stai per aprire',
                position: 'right',
                doneBtnText: 'Fatto',
                closeBtnText: 'Chiudi',
                nextBtnText: 'Successivo',
                prevBtnText: 'Precedente',
              }
            },
            {
              element: 'button.Button.Button--primary.IndexPage-newDiscussion.hasIcon',
              popover: {
                title: 'Inizia una discussione.',
                description: 'Clicca su questo pulsante per iniziare una discussione nel tag selezionato!',
                position: 'right',
                doneBtnText: 'Fatto',
                closeBtnText: 'Chiudi',
                nextBtnText: 'Successivo',
                prevBtnText: 'Precedente',
              }
            },
            {
              element: '.DiscussionList',
              popover: {
                title: 'La tua discussione',
                description: 'Ora non resta che attendere che altri utenti rispondano alla tua discussione!',
                position: 'right',
                doneBtnText: 'Fatto',
                closeBtnText: 'Chiudi',
                nextBtnText: 'Successivo',
                prevBtnText: 'Precedente',
              }
            },
          ]);

          driver.start();
        },2000);
      }
      localStorage.setItem('noTutorialBefore', true)
    }
  })
});


